import moment from "moment-timezone";
import {handleUrlWithHashtag} from "../GetUrlParams";

export function getCookie(name: string) {
    let regEx = new RegExp(name + "=([^;]+)");
    let cookieValue = regEx.exec(document.cookie);
    return (cookieValue != null) ? decodeURI(cookieValue[1]) : null;
}

export const Check24rCookie = () => {
    if(!getCookie('24rent') || isNaN(Number(getCookie('24rent')))) {
        let id = moment().unix().toString();
        for( let i = 0; i < 5; ++i) {
            id += Math.floor( Math.random() * 10);
        }
        let cookieExpires = moment().add(10, 'years').format('YYYY-MM-DDTHH:mm:ssZ');
        document.cookie = "24rent=" + id + '; expires=' + cookieExpires;
    }

    const campaign = new URLSearchParams(handleUrlWithHashtag()).get("campaign");
    if (campaign && !getCookie('lumo')) {
        if (campaign.toLowerCase() === 'lumo') {
            let date = new Date();
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 year cookie
            document.cookie = "lumo=1;expires=" + date.toUTCString();
        }
    }

    return getCookie('24rent');
}

export interface ICustomerBehaviourData {
    utm_campaign?: string,
    utm_source?: string,
    utm_term?: string,
    utm_medium?: string,
    utm_content?: string,
    gclid?: string,
    cid?: string,
    app_platform?: string,
}

/**
 * Which surface the RRM is running on. `app_*` means we are inside the React
 * Native launcher's webview; `chauffeur` is the chauffeur app; everything else
 * is a plain browser.
 */
export type Surface = 'app_ios' | 'app_android' | 'app_unknown' | 'chauffeur' | 'web';

/** sessionStorage key holding the platform sent by the launcher on the entry URL. */
export const APP_PLATFORM_KEY = 'app_platform';

/**
 * Resolve the current surface.
 *
 * `redirectRef` is the PRIMARY signal: App.tsx strips it from the URL and persists
 * it to sessionStorage, so it survives every step of the booking flow. `app_platform`
 * only ever rides the launcher's ENTRY url and is lost the moment the flow leaves
 * this document — most importantly the Walley payment step, which returns via a
 * `24launcher.` return domain that api4 maps to a `rentapp://` deep link. Reading
 * app_platform straight off the URL would therefore drop the platform on `purchase`,
 * the one event that matters most, so we mirror it into sessionStorage on first sight.
 */
export const GetSurface = (): Surface => {
    const urlPlatform = new URLSearchParams(handleUrlWithHashtag()).get(APP_PLATFORM_KEY);
    if (urlPlatform) {
        sessionStorage.setItem(APP_PLATFORM_KEY, urlPlatform);
    }

    const ref = sessionStorage.getItem('redirectRef');
    if (ref === 'chauffeur') return 'chauffeur';
    if (ref !== 'launcher') return 'web';

    const platform = urlPlatform ?? sessionStorage.getItem(APP_PLATFORM_KEY);
    if (platform === 'ios') return 'app_ios';
    if (platform === 'android') return 'app_android';
    // Launcher confirmed, but no platform — an app build older than the one that
    // started sending app_platform. Still app traffic, just not attributable to an OS.
    return 'app_unknown';
}

export const GetCustomerBehaviourParams = () => {
    const search = handleUrlWithHashtag();
    const utm_campaign = new URLSearchParams(search).get('utm_campaign') ?? '';
    const utm_source =  new URLSearchParams(search).get('utm_source') ?? '';
    const utm_term =  new URLSearchParams(search).get('utm_term') ?? '';
    const utm_medium =  new URLSearchParams(search).get('utm_medium') ?? '';
    const utm_content =  new URLSearchParams(search).get('utm_content') ?? '';
    const gclid =  new URLSearchParams(search).get('gclid') ?? '';
    const cid =  new URLSearchParams(search).get('cid') ?? '';
    // Sent by the launcher webview (ReactNativeFE CustomWebView). Read via
    // GetSurface() so it also picks up the sessionStorage mirror after a payment
    // redirect has stripped the query string.
    const app_platform = new URLSearchParams(search).get('app_platform')
        ?? sessionStorage.getItem(APP_PLATFORM_KEY) ?? '';

    return {utm_campaign: utm_campaign, utm_source: utm_source, utm_term: utm_term,
        utm_medium: utm_medium, utm_content: utm_content, gclid: gclid, cid: cid,
        app_platform: app_platform}
}

